import { useContext } from 'react';
import { DarkstoreContext } from './Darkstore';

export default () => useContext(DarkstoreContext);
